/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 01.07.2016
 *
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import {
    Button,
    ButtonToolbar,
    Container,
    Dropdown,
    DropdownButton,
    FormControl,
    FormGroup,
    FormLabel,
    InputGroup
} from 'external/react-bootstrap';

import { amdRequire, Title, ValidationMessage } from 'plugin/liferay-widgets-react-web';

class MapConfigEditPluginForm extends React.Component {

    constructor(props){
        super(props);

        // all available plugins
        this.ELEMENTS = Object.keys(amdRequire.s.contexts._.config.map['*']).filter(n => n.indexOf('map/plugins') >= 0);
        // already chosen plugins
        this.chosenPlugins = props.formData && props.formData.plugins && props.formData.plugins.map(p => p.path) || [];
        // remove chosen plugins from available plugins
        this.availablePlugins = this.ELEMENTS.filter(p => this.chosenPlugins.indexOf(p) < 0);

        if (this.props.formData.isNew) {
            this.state = {
                path: '',
                config: '',
                availablePlugins: this.availablePlugins
            };
        } else {
            this.state = {
                ...props.formData.plugin,
            };
        }
    }

    handlePathChange(e){
        this.setState({
            path: e.target.value,
            pathValid: e.target.value.trim() ? undefined : 'Pfad ungültig'
        });
    }

    handleConfigChange(e){
        let configValid;
        try {
            JSON.parse(e.target.value);
        } catch (e) {
            configValid = e.message;
        }

        this.setState({
            config: e.target.value,
            configValid
        });
    }

    handleSubmit(e){
        e.preventDefault();

        const { path, config } = this.state;

        if (!path) {
            return;
        }

        this.props.onSubmit({
            ...this.props.plugin,
            isNew: this.props.formData.isNew,
            path,
            config
        });
    }

    onSelectPlugin(p){
        this.setState({
            path: p
        });
    }

    render(){
        const { path, config, availablePlugins } = this.state;
        const { isNew, } = this.props.formData;

        return (
            <Container className="py-3">
                <Title title={isNew ? 'Plugin hinzufügen' : 'Plugin bearbeiten'}/>

                <p>Bitte gib den Pfad und die Konfiguration des {isNew && <span>neuen</span>} Plugins ein.</p>

                <FormGroup>
                    <InputGroup>
                        <FormControl
                            type="text" placeholder="Pfad" value={path}
                            onChange={this.handlePathChange.bind(this)}
                        />
                        <InputGroup.Append>
                            <DropdownButton
                                id="input-dropdown-addon"
                                title="Plugins"
                            >
                                {
                                    isNew && availablePlugins.map((p, i) =>
                                        <Dropdown.Item key={i} onClick={this.onSelectPlugin.bind(this, p)}>
                                            {p}
                                        </Dropdown.Item>)
                                }
                            </DropdownButton>
                        </InputGroup.Append>
                    </InputGroup>
                    <ValidationMessage formValidation={this.state} propName="pathValid"/>
                </FormGroup>

                <FormGroup>
                    <FormLabel>Konfiguration</FormLabel>
                    <FormControl as="textarea"
                                 placeholder="Konfiguration"
                                 value={config}
                                 onChange={this.handleConfigChange.bind(this)}/>
                    <ValidationMessage formValidation={this.state} propName="configValid"/>
                </FormGroup>

                <ButtonToolbar>
                    <Button variant="primary"
                            type="button"
                            onClick={this.props.onCancel.bind(this)}
                    >
                        Abbrechen
                    </Button>

                    <Button variant="primary"
                            type="submit"
                            onClick={this.handleSubmit.bind(this)}
                    >
                        Speichern
                    </Button>

                </ButtonToolbar>

            </Container>
        );
    }
}

MapConfigEditPluginForm.propTypes = {
    formData: PropTypes.object,
    plugin: PropTypes.object,
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func
};

export default MapConfigEditPluginForm;



// WEBPACK FOOTER //
// ./js/components/MapConfigEditPluginForm.jsx